import {combineReducers} from 'redux';
import user from './user';
import app from './app';

const reducer = combineReducers({
  app,
  user,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return reducer(state, action);
};

export default rootReducer;
